<div class="about-us-page">
    <app-hero-about></app-hero-about>
    <app-do-more-games></app-do-more-games>
    <app-what-we-offer></app-what-we-offer>
    <app-why-choose></app-why-choose>
    <app-join-revolution></app-join-revolution>
</div>


